import { PUBLIC_URL } from 'app/consts'

export const makePublicUrl = (filePath: string): string =>
  `${PUBLIC_URL}/${filePath}`
